import script from "./FavoriteBottomSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoriteBottomSheet.vue?vue&type=script&setup=true&lang=js"

import "./FavoriteBottomSheet.vue?vue&type=style&index=0&id=54b8fcaa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b8fcaa"]])

export default __exports__